import { forwardRef, useImperativeHandle } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $generateHtmlFromNodes } from '@lexical/html';

export const ExportPlugin = forwardRef((_props, ref) => {
  const [editor] = useLexicalComposerContext();

  useImperativeHandle(ref, () => ({
    getHtmlAsync: getHtmlAsync,
  }));

  function getHtmlAsync() {
    return new Promise((resolve, reject) => {
      try {
        editor.getEditorState().read(() => {
          const html = $generateHtmlFromNodes(editor, null);
          resolve(html);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  return null;
});
